export const SUPERADMIN = 'SuperAdmin'
export const OWNER = 'Owner'
export const COLLABORATOR = 'Collaborator'
export const LEARNER = 'Learner'
